import initialState from './initialState';
import { reducer as listDeploymentSettingReducer } from './listDeploymentSetting';
import { reducer as createDeploymentSettingReducer } from './createDeploymentSetting';
import { reducer as deleteDeploymentSettingReducer } from './deleteDeploymentSetting';
import { reducer as updateDeploymentSettingReducer } from './updateDeploymentSetting';
import { reducer as publishDeploymentSettingReducer } from './publishDeploymentSetting';
import { reducer as loadProjectDepSettingReducer } from './loadProjectDepSetting';
import { reducer as loadCodeExportRequestListReducer } from './loadCodeExportRequestList';
import { reducer as loadPermissionFlagsReducer } from './loadPermissionFlags';
import { reducer as exportProjectCodeReducer } from './exportProjectCode';
import { reducer as deleteExportRequestReducer } from './deleteExportRequest';
import { reducer as loadDownloadCodeHistoryReducer } from './loadDownloadCodeHistory';
import { reducer as toggleCodeExportReducer } from './toggleCodeExport';
import { reducer as requestUpgradeAccountReducer } from './requestUpgradeAccount';
import { reducer as saveDbExportRequestReducer } from './saveDbExportRequest';
import { reducer as deleteDbExportRequestReducer } from './deleteDbExportRequest';
import { reducer as loadDbExportRequestListReducer } from './loadDbExportRequestList';
import { reducer as deleteGithubExportRequestReducer } from './deleteGithubExportRequest';
import { reducer as listGithubExportListReducer } from './listGithubExportList';
import { reducer as createGithubExportSettingReducer } from './createGithubExportSetting';
import { reducer as loadGithubUserDataReducer } from './loadGithubUserData';
import { reducer as pushToGitHubReducer } from './pushToGitHub';

const reducers = [
  listDeploymentSettingReducer,
  createDeploymentSettingReducer,
  deleteDeploymentSettingReducer,
  updateDeploymentSettingReducer,
  publishDeploymentSettingReducer,
  loadProjectDepSettingReducer,
  loadCodeExportRequestListReducer,
  loadPermissionFlagsReducer,
  exportProjectCodeReducer,
  deleteExportRequestReducer,
  loadDownloadCodeHistoryReducer,
  toggleCodeExportReducer,
  requestUpgradeAccountReducer,
  saveDbExportRequestReducer,
  deleteDbExportRequestReducer,
  loadDbExportRequestListReducer,
  deleteGithubExportRequestReducer,
  listGithubExportListReducer,
  createGithubExportSettingReducer,
  loadGithubUserDataReducer,
  pushToGitHubReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
